import {Injectable} from "@angular/core";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {CreateDeliveryPointData} from "@app/core/delivery-point/application/dtos/create-delivery-point-data";
import {Observable} from "rxjs";
import {first} from "rxjs/operators";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";

/**
 * Use case for add an existing delivery point to the user's account.
 */
@Injectable({
    providedIn: 'root'
})
export class CreateDeliveryPointUseCase {

    constructor(
        private deliveryPointRemote:DeliveryPointRemote,
        private credentialsStorage:CredentialsStorage,
    ) {
    }

    /**
     * It adds an existing delivery point to the user's account.
     * @param createDeliveryPointData - The data used to add the delivery point.
     * @returns An observable that emits the added delivery point.
     */
    execute(createDeliveryPointData:CreateDeliveryPointData): Observable<DeliveryPoint> {
        const temporalCredentials = this.credentialsStorage.getTemporalCredentials();
        //If there are temporal credentials, that means that the user is not logged in and wants to create a delivery point before logging in.
        //In that case, the temporal credentials will be used to create the delivery point.
        if (temporalCredentials !== null) {
            return this.deliveryPointRemote.createDeliveryPoint(createDeliveryPointData, temporalCredentials);
        }
        return this.deliveryPointRemote.createDeliveryPoint(createDeliveryPointData).pipe(first());
    }

}
